/**
 * Hook for updating user status (INACTIVE/ACTIVE) via PATCH /api/admin/users/:id/status.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { updateUserStatus } from '../services/userManagementService';

export function useUpdateUserStatus(
  userId: string | undefined,
  options?: {
    onSuccess?: () => void;
    onError?: (err: unknown) => void;
  }
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (status: 'ACTIVE' | 'INACTIVE') => {
      if (!userId) throw new Error('userId required');
      return updateUserStatus(userId, status);
    },
    onSuccess: (_, status) => {
      const label = status === 'ACTIVE' ? 'Đã kích hoạt' : 'Đã vô hiệu hóa';
      message.success(label);
      queryClient.invalidateQueries({ queryKey: ['user', userId, 'overview'] });
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
      options?.onSuccess?.();
    },
    onError: (err: unknown) => {
      const ax = err as { response?: { data?: { message?: string } } };
      message.error(
        ax.response?.data?.message || 'Cập nhật trạng thái thất bại'
      );
      options?.onError?.(err);
    },
  });
}
